import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";

import HeroSection from "./components/HeroSection";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhyChoose from "./components/WhyChoose";
import About from "./components/About";
import Contact from "./components/Contact";
import Team from "./components/Team";
import OTGuidelines from "./components/OTGuidelines";
import Services from "./components/Services";
import Clients from "./components/Clients";
import AllClients from "./components/AllClients";
import Gallery from "./components/Gallery";
import GalleryFull from "./components/GalleryFull";
import ScrollToTop from "./components/ScrollToTop";
import FounderPage from "./components/FounderPage";
import CustomerReviews from "./components/CustomerReviews";

/* ─────────────────────────────────────────────
   HOME PAGE
───────────────────────────────────────────── */
function HomePage() {
  return (
    <>
      <Helmet>
        <title>Modular OT Manufacturer in India | WEMS Pune</title>
        <meta
          name="description"
          content="WEMS is a leading modular OT manufacturer in India providing operation theatre setup, laminar airflow systems, ICU, NICU and hospital infrastructure solutions."
        />
      </Helmet>

      <Header />
      <HeroSection />
      <WhyChoose />
      <Gallery />
      <About />
      <Services />
      <Clients />
      <OTGuidelines />
      
      

      <Team />
      <Contact />
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────────
   SERVICES PAGE
───────────────────────────────────────────── */
function ServicesPage() {
  return (
    <>
      <Helmet>
        <title>
          Modular OT Services India | Operation Theatre Setup | WEMS
        </title>
        <meta
          name="description"
          content="Explore modular OT services including laminar airflow, ICU, NICU, PICU and complete hospital operation theatre setup by WEMS India."
        />
      </Helmet>

      <Header />
      <Services />
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────────
   CLIENTS PAGE
───────────────────────────────────────────── */
function ClientsPage() {
  return (
    <>
      <Helmet>
        <title>
          Hospital OT Projects India | Modular OT Installations | WEMS
        </title>
        <meta
          name="description"
          content="View completed modular OT projects, hospital operation theatre installations and healthcare infrastructure delivered by WEMS across India."
        />
      </Helmet>

      <Header />
      <AllClients />
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────────
   GALLERY PAGE
───────────────────────────────────────────── */
function GalleryPage() {
  return (
    <>
      <Helmet>
        <title>
          Modular OT Gallery | Operation Theatre Images India | WEMS
        </title>
        <meta
          name="description"
          content="Browse modular OT installations, laminar airflow operation theatres and hospital OT images by WEMS India."
        />
      </Helmet>

      <Header />
      <GalleryFull />
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────────
   CONTACT PAGE
───────────────────────────────────────────── */
function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Modular OT Manufacturer | WEMS Pune India</title>
        <meta
          name="description"
          content="Contact WEMS for modular OT design, laminar airflow systems and hospital operation theatre setup. Get a free consultation today."
        />
      </Helmet>

      <Header />
      <Contact />
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────────
   404 PAGE
───────────────────────────────────────────── */
function NotFound() {
  return (
    <>
      <Header />
      <div style={{ textAlign: "center", padding: "8rem 2rem" }}>
        <h1 style={{ fontSize: "3rem", color: "#0a1f44" }}>404</h1>
        <p style={{ fontSize: "1.2rem", color: "#555" }}>Page not found.</p>
        <a href="/" style={{ color: "#00bcd4", fontWeight: 600 }}>
          ← Back to Home
        </a>
      </div>
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────────
   APP ROOT
───────────────────────────────────────────── */
function App() {
  useEffect(() => {
    AOS.init({ duration: 300, once: true });
  }, []);

  return (
    <>
      {/* Default SEO fallback */}
      <Helmet>
        <title>WEMS | Modular OT Manufacturer India</title>
        <meta
          name="description"
          content="WEMS provides modular operation theatre setup, ICU, NICU, PICU and laminar airflow systems in India."
        />
      </Helmet>

      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* 🔥 SEO ROUTES */}
        <Route path="/modular-ot-services" element={<ServicesPage />} />
        <Route path="/hospital-ot-projects" element={<ClientsPage />} />
        <Route path="/modular-ot-gallery" element={<GalleryPage />} />
        <Route path="/contact-modular-ot" element={<ContactPage />} />
        <Route
          path="/customer-reviews"
          element={
            <>
              <Header />
              <CustomerReviews />
              <Footer />
            </>
          }
        />

        {/* KEEP */}
        <Route path="/vaibhav-anpat" element={<FounderPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
